import { LIST_CASHIERS } from '@/data/actions/modules/financial';
import MyCashRegister from './components/MyCashRegister.vue';
import Receive from './components/Receive.vue';
import Sessions from './components/Sessions.vue';
import SessionDetail from './components/SessionDetail.vue';
// TODO(rollout-caixa-novo): reativar assim que esta versão subir
// import Settings from './components/Settings.vue';
import Moved from './components/Moved.vue';

const meta = {
  layout: 'master',
  requiresAuth: true,
};

const treasuryMeta = {
  ...meta,
  permission: LIST_CASHIERS,
};

export default [
  {
    path: '/cash-register',
    component: () => import(/* webpackChunkName: "cash-register" */ './components/Main.vue'),
    meta,
    children: [
      { path: '', component: MyCashRegister, meta },
      { path: 'receive', component: Receive, meta },
      { path: 'receive/:appointmentId', component: Receive, meta },
      // TODO(rollout-caixa-novo): reativar assim que esta versão subir
      // { path: 'settings', component: Settings, meta },
      { path: 'moved', component: Moved, meta },
    ],
  },
  {
    path: '/financial/cash-register-sessions',
    component: Sessions,
    meta: treasuryMeta,
  },
  {
    path: '/financial/cash-register-sessions/:id',
    component: SessionDetail,
    meta: treasuryMeta,
  },
];
